import "popper.js"
import "bootstrap/js/dist/util"
import "bootstrap/js/dist/collapse"
import "bootstrap/js/dist/dropdown"
import "jquery-match-height"
import "magnific-popup"
import "slick-carousel"
import debounce from "lodash/debounce"
import Scroller from "./components/scroller"

class App {
  static init() {
    $(".wpcf7").on("submit", event => {
      const button = $(event.target).find("button[type=submit]")
      button.attr("disabled", true)
      button.addClass("loader")
    })

    $(".wpcf7").on("wpcf7submit", event => {
      const button = $(event.target).find("button[type=submit]")
      button.attr("disabled", false)
      button.removeClass("loader")
    })

    $(".wpcf7 select").on("change", event => {
      const { value } = event.target.options[event.target.options.selectedIndex]
      event.target.classList.toggle("filled", value.length)
    })

    new Scroller().watch()

    $(document).ready(() => {
      $(".popup-iframe").magnificPopup({
        disableOn: 700,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      })
    })

    $(window).on(
      "load ready resize",
      debounce(() => {
        const $header = $("header.main")
        const $content = $(".wrap main")

        $content.css({
          paddingTop: $header.css("position") === "fixed" ? $header.height() : 0
        })
      }, 20)
    )

    $("section.latest-news .slick-slider").slick({
      slidesToShow: 1,
      centerMode: true,
      centerPadding: "5%",
      prevArrow:
        '<button type="button" class="slick-prev"><span class="svg-container icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="59" viewBox="0 0 30 59"><defs><path id="a" d="M203.5 5338.5l-27-28.68 27-27.32"/></defs><use fill="#fff" fill-opacity="0" stroke="#fff" stroke-miterlimit="50" stroke-width="2" xlink:href="#a" transform="translate(-175 -5281)"/></svg></span></button>',
      nextArrow:
        '<button type="button" class="slick-next"><span class="svg-container icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="59" viewBox="0 0 30 59"><defs><path id="ta1xa" d="M1259.5 5338.5l27-28.68-27-27.32"/></defs><g><g transform="translate(-1258 -5281)"><use fill="#fff" fill-opacity="0" stroke="#fff" stroke-miterlimit="50" stroke-width="2" xlink:href="#ta1xa"/></g></g></svg></span></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerPadding: 0,
            arrows: false,
            dots: true,
            adaptiveHeight: true
          }
        }
      ]
    })

    $(".js-toggle-mega-menu").on("click", e => {
      const $el = $(e.currentTarget)

      $el.parents(".mega-menu").toggleClass("active")
    })
  }
}

App.init()
